export function check_input(value) {
  return (
    (value.error === undefined) &&
    (value.complete === true) &&
    (value.empty === false)
  )
}
